import * as yup from "yup";

export default () => yup.object().shape({
  aboutMe: yup.string().trim()
    .max(10000, "text_too_long"),
});
